import {DimensionItem} from '@selpia/shared/models';

import {DimensionItemNode} from '../models';


export class DimensionItemConverter {

  static getDimensionItemsNodeMap(dimensionItems: Map<string, DimensionItem[]> | undefined): Map<string, DimensionItemNode> | undefined {
    if (!dimensionItems) {
      return undefined;
    }
    const entries = dimensionItems.entries();
    const nodesEntries: [string, DimensionItemNode][] = Array.from(entries)
      .map(
        ([dimensionName, items]) => [dimensionName, DimensionItemConverter.treeFromDimensionItems(items)],
      );
    return new Map<string, DimensionItemNode>(nodesEntries);
  }

  static treeFromDimensionItems(dimensionItems: DimensionItem[]): DimensionItemNode {
    const copy: DimensionItem[] = dimensionItems.slice();
    const rootIndex: number = copy.findIndex((item) => !item.parentCode);
    if (rootIndex === -1) {
      throw new Error('No root dimension found (TOTAL for dimension)');
    }
    const root: DimensionItem | undefined = copy.splice(rootIndex, 1)
      .at(0);
    if (!root) {
      throw new Error('No root (no TOTAL for dimension)');
    }

    return {element: root, children: this.getChildren(root.code, dimensionItems)};
  }

  private static getChildren(parentCode: string, dimensionItems: DimensionItem[]): DimensionItemNode[] | null {
    const children: DimensionItem[] = dimensionItems.filter((item) => item.parentCode === parentCode);
    if (children.length === 0) {
      return null;
    }
    return children.map((child) => ({element: child, children: this.getChildren(child.code, dimensionItems)}));
  }
}
